"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("../../../store/store");
const WebsiteHeader = () => {
    const { appSettings } = (0, store_1.useAppSelector)((state) => state.app);
    if (!appSettings)
        return null;
    const { theme: { images: { logo: { src, alt }, }, }, } = appSettings;
    return ((0, jsx_runtime_1.jsxs)("div", { id: "website-header", children: [(0, jsx_runtime_1.jsx)("div", { className: "logotype", children: (0, jsx_runtime_1.jsx)("img", { src: src, alt: __.trans(alt) }) }), (0, jsx_runtime_1.jsxs)("a", { href: "https://geblod.nu", className: "to-website", tabIndex: 0, children: [(0, jsx_runtime_1.jsx)("i", { className: "icon icon-geblod_ikon_pil" }), (0, jsx_runtime_1.jsx)("span", { children: __.trans('login.login-header-link-to-geblod') })] })] }));
};
exports.default = WebsiteHeader;
